module.exports = __webpack_public_path__ + "1948ac94.gif";